import React from 'react';
import classNames from 'classnames';
/*
 * Bronson ProductInfoSummary component.
 */
export function ProductInfoSummary({ className, compact, imgAlt, imgProps, imgSizes, imgSrc, imgSrcSet, infoLabel, infoValue, subtitle, title, testId, ...otherProps }) {
    const divClassNameList = classNames({
        'c-product-info-summary ': true,
        // main class modifier convenience prop extension
        'c-product-info-summary--compact ': compact, // Convenience prop from Bronson variants.
    }, className).trim();
    function renderIfProductInfoSummaryImg() {
        if (imgSrc || imgSrcSet) {
            return (React.createElement("span", { className: "c-product-info-summary__img" },
                React.createElement("img", { src: imgSrc, srcSet: imgSrcSet, sizes: imgSizes, alt: imgAlt, ...imgProps })));
        }
        return null;
    }
    function renderIfProductInfoSummarySubtitle() {
        if (subtitle) {
            return React.createElement("span", { className: "c-product-info-summary__subtitle" }, subtitle);
        }
        return null;
    }
    return (React.createElement("div", { ...otherProps, "data-testid": testId, className: divClassNameList },
        renderIfProductInfoSummaryImg(),
        React.createElement("span", { className: "c-product-info-summary__heading" },
            React.createElement("span", { className: "c-product-info-summary__title" }, title),
            renderIfProductInfoSummarySubtitle()),
        React.createElement("span", { className: "c-product-info-summary__info" },
            React.createElement("span", { className: "c-product-info-summary__info-label" }, infoLabel),
            React.createElement("span", { className: "c-product-info-summary__info-value" }, infoValue))));
}
